import api from '../utils/api';

/** Admin catalog — legacy payment routes (SubscriptionPlan planCategory=addon). */
export function listAddonPlans(params = {}) {
  return api.get('/get-addonplans', { params });
}

export function createAddonPlan(body) {
  return api.post('/create-addonplan', body);
}

export function updateAddonPlan(id, body) {
  return api.put(`/put/addon/plan/${id}`, body);
}

export function deleteAddonPlan(id) {
  return api.delete(`/delete/addon/plan/${id}`);
}

export function setAddonPlanStatus(planId, status) {
  return api.patch(`/update-addonplan-status/${planId}`, { status });
}
